import { useEffect } from 'react';

/**
 * KD3 S2411 — ตัวกรองบริษัทจาก URL (`?company=` / `?company_id=`) ที่ไม่อยู่ในรายชื่อบริษัท
 *
 * เปิดลิงก์/บุ๊กมาร์กของบริษัทที่ถูกลบไปแล้ว (หรือพิมพ์ id เอง) → dropdown ไม่มี option ให้เลือกจึงขึ้น
 * "ทั้งหมด" ขณะที่ API ยังกรอง company_id นั้นอยู่ ตารางว่าง "ไม่พบข้อมูล" = จอพูดคนละเรื่องกับผลลัพธ์
 * และผู้ใช้ไม่มีทางรู้ว่าต้องกด "ล้าง" · ทิ้งตัวกรองนั้นเมื่อโหลดรายชื่อเสร็จ
 *
 * ทิ้งเฉพาะเมื่อรายชื่อครบแล้ว (items >= total) — ถ้าวันหนึ่งบริษัทเกิน limit ของ dropdown จะไม่ตัดบริษัทจริงทิ้ง
 */
export function useDropUnknownCompanyFilter(
  companies: ReadonlyArray<{ id: number }> | undefined,
  totalCompanies: number | undefined,
  selectedCompanyId: number | string | null | undefined,
  clearCompanyFilter: () => void,
): void {
  useEffect(() => {
    if (!companies || totalCompanies === undefined) return;
    if (selectedCompanyId === undefined || selectedCompanyId === null || selectedCompanyId === '') return;
    if (companies.length < totalCompanies) return;
    const id = Number(selectedCompanyId);
    if (!companies.some(c => c.id === id)) clearCompanyFilter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companies, totalCompanies, selectedCompanyId]);
}

export default useDropUnknownCompanyFilter;
